import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Qs from 'qs'
import store from './store'
import tpheader from './pages/tpheader/TpHeader.vue'
import tpfooter from './pages/tpfooter/TpFooter.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'default-passive-events'

Vue.prototype.$http = axios

Vue.use(ElementUI);

Vue.config.productionTip = false

Vue.prototype.loginRemind = false;

Vue.component('tpheader', tpheader);
Vue.component('tpfooter', tpfooter);

// 本地测试
// Vue.prototype.testUrl = "http://zzrc.ca163.net";
Vue.prototype.testUrl = "https://zzch.ca163.net";
// Vue.prototype.testUrl = "http://zzrc-test.ca163.net";
// Vue.prototype.testUrl = "https://test-zzch.ca163.com";

// // 测试服
// Vue.prototype.baseUrl = 'http://test-zzch-server.ca163.com/index.php/';
// //图片
// Vue.prototype.imgUrl = 'http://zzpt-oss.oss-accelerate.aliyuncs.com/img_product/';
// //wold和pdf
// Vue.prototype.wordUrl = 'http://test-zzch-server.ca163.com/work/';
// //音频
// Vue.prototype.musicUrl = 'http://test-zzch-server.ca163.com/music/';
// //辅导员课件
// Vue.prototype.classUrl = 'http://test-zzch-server.ca163.com/class/';
// //轮播图链接
// Vue.prototype.bannerUrl = 'http://zzpt-oss.oss-accelerate.aliyuncs.com/banner/';
// //导出excel
// Vue.prototype.exportUrl = 'http://test-zzch-server.ca163.com/export_excel/';

// // // 正式服
Vue.prototype.baseUrl = 'https://zzpt.ca163.net/';
Vue.prototype.imgUrl = 'http://zzpt-oss.oss-accelerate.aliyuncs.com/img_product/';
Vue.prototype.bannerUrl = 'http://zzpt-oss.oss-accelerate.aliyuncs.com/banner/';
Vue.prototype.wordUrl = 'https://zzpt.ca163.net/work/';
Vue.prototype.musicUrl = 'https://zzpt.ca163.net/music/';
Vue.prototype.exportUrl = 'https://zzpt.ca163.net/export_excel/';
Vue.prototype.classUrl = 'https://zzpt.ca163.net/class/';

//根据域名获取店铺id
Vue.prototype.$getStoreId = function () {
    let data = {};

    // 线上 start
    let hostName = window.location.hostname;
    // 指向人才
    let belongToZZRC = `
    jxjy.zzrc.cn,
    http://zzrc-uat.ca163.net.cn,
    http://zzrc.ca163.net,
    https://zzrc.ca163.net,
    zzrc-uat.ca163.com`;
    if (belongToZZRC.includes(hostName)) {
        data.url = "http://zzrc.ca163.net";
    } else {
        data.url = window.location.origin;
    }
    // 指向畅和
    let belongToZZCH = `zzch-uat.ca163.net.cn,
    zzch.ca163.net,
    zzch-uat.ca163.com,
    http://jxjy.zzzjedu.com`;
    if (belongToZZCH.includes(hostName)) {
        data.url = "http://zzch-test.ca163.net";
    } else {
        data.url = window.location.origin;
    }
    // 线上 end

    // // 本地测试
    // data.url = this.testUrl

    return this.$post("shops/get_url", data).then(res => {
        return res.data.result.id;
    });
}

//get请求
Vue.prototype.$get = function (api, data) {
    if (data === undefined) {
        data = {};
    }
    var ox = axios.get(this.baseUrl + api, { params: data });
    return ox;
}

//post请求
Vue.prototype.$post = function (api, data) {
    data = Qs.stringify(data);
    var ox = axios.post(this.baseUrl + api, data);
    return ox;
}

//上传跨域问题
Vue.prototype.$upload = function (url, q) {
    let Fromdata = new FormData()
    Fromdata.append('file', q.file)
    Fromdata.append('shop_id', this.$store.state.store.id)
    Fromdata.append('token', this.$store.state.authority_management)
    // console.log(q.file);
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    // console.log(Fromdata);
    // console.log(url);
    let upload = axios.post(url, Fromdata, config)
    return upload
}



Vue.prototype.$Qs = function (data) {
    data = Qs.stringify(data);
    let ox = data
    return ox;
}

// Vue.prototype.$http = function (api, data, headers) {
//     data = Qs.stringify(data);
//     var ox = axios.post(this.baseUrl + api, data,headers);
//     return ox;
// }


//判断数据是否异常
Vue.prototype.$isAbnormal = function (val) {
    return val == '' || String(val) == 'undefined' || String(val) == 'null';
}

//判断跳转学习页面
Vue.prototype.$toClass = function (id, is_project, purchased_id) {
    //多端判断
    if (this.$store.state.id) {
        //如果登录则再判断是否已经购买该课程
        this.$post('users/isPay', { product_id: id, token: this.$store.state.id }).then(res => {
            // console.log(res.data.result);
            let path = '';
            let purchased_id = '';
            // 返回true则没有购买，返回一个数组就说明已经购买
            // 若已经购买课程则跳转学习页面，若没有则跳转详情页面
            if (res.data.result == true && is_project == 0) {
                path = '/classdetails'
            } else if (res.data.result == true && is_project == 1) {
                path = '/detailsPage';
            } else if (res.data.result != true && is_project == 0) {
                path = '/classstudy';
                purchased_id = res.data.result[0].purchased_id
            } else {
                path = '/lessonstudy';
            }
            let address = this.$router.resolve({
                path: path,
                query: {
                    id: id,
                    purchased_id: purchased_id
                }
            });
            window.open(address.href, "_blank")
        })
    } else {
        //如果没有登录则跳转课程详情
        let noLoginPath = '';
        is_project == 0 ? noLoginPath = '/classdetails' : noLoginPath = '/detailsPage';
        let address = this.$router.resolve({
            path: noLoginPath,
            query: {
                id: id
            }
        });
        window.open(address.href, "_blank");

    }
}



new Vue({
    router,
    store,
    // data(){
    //   return {
    //     isGetData:false,
    //   }
    // },
    render: h => h(App)
}).$mount('#app')
